module.exports = __webpack_public_path__ + "img/flexsale_hifi_3.622f6948.png";